import styled from "styled-components";
import { palette } from "styled-theme";

const ImageUploaderWrapper = styled.div`
  .outer {
    width: 160px;
    height: 160px;
    border-radius: 80px;
    .inner {
      width: 160px;
      height: 160px;
      display: flex;
      justify-content: center;
      align-items: center;
      svg {
        font-size: 100px;
        color: ${palette("border", 0)};
      }
      img {
        width: 160px;
        height: 160px;
        border-radius: 80px;
      }
    }
    .camera {
      width: 36px;
      height: 36px;
      border-radius: 18px;
      background-color: ${palette("primary", 0)};
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: -40px;
      margin-right: 5px;
      border: 3px solid ${palette("surfaceColor", 0)};
      position: absolute;

      svg {
        font-size: 14px;
        color: ${palette("surfaceColor", 0)};
      }
    }
  }
  .removeContainer {
    padding-top: 10px;
    width: 160px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export default ImageUploaderWrapper;
